module.exports = __webpack_public_path__ + "static/media/tianxing.aa84fb00.svg";